import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWelderUpdates(id: string) {
  return useQuery(queryKeys.welder.updates(id), () => {
    return api.getWelderUpdates(id);
  });
}
